<template>
  <div class="shop-cart">
    <template v-if="basketList.length">
      <div class="logistic-content container" v-for="takeInfo in basketList" :key="takeInfo.id">
        <div class="logistic-top">
          <el-checkbox v-model="takeInfo.checked" @change="(val) => selectLogistic(val, takeInfo.takeType)" :true-label="1" :false-label="0">
            <div class="take-type-title">
              <span>{{ takeInfo.takeTypeDesc }} {{ takeInfo.takeTypeDescEn }}</span>
            </div>
          </el-checkbox>
        </div>
        <div class="tenant-container">
          <div v-for="item in takeInfo.storeInfoList" :key="item.id" class="tenant-item">
            <car-item
              :info="item"
              :takeType="takeInfo.takeType"
              @changeShopSelectAll="changeShopSelectAll"
              @chaneSelect="chaneSelect"
              @handleDelete="handleDelete"
              @changeCount="changeCount"
            />
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="footer-inner container primary-text">
          <el-checkbox v-model="checkedAll" :true-label="1" :false-label="0" @change="handleSelectAll">
            全选 All of them
          </el-checkbox>
          <div class="footer-right">
            <span>合计 Total：</span>
            <span>￥{{ totalAmount }}</span>
            <el-button type="primary" class="settle-btn" @click="toConfrimOrder">去结算 To settle up</el-button>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <el-empty :image-size="200"></el-empty>
    </template>
  </div>
</template>

<script>
import GoodsPanel from "@/components/base/GoodsPanel";
import TablePage from "@/components/base/TablePage";
import SearchBar from "@/components/base/SearchBar";
import CarItem from "./components/CarItem";
import moment from "moment";
import { Loading } from "element-ui";
export default {
  name: "",
  components: { GoodsPanel, TablePage, SearchBar, CarItem },
  data() {
    return {
      basketList: [], //购物车信息
      totalAmount: "", //总金额
      isLogin: false,
      checkedAll: 0,
    };
  },
  props: {},
  computed: {},
  async mounted() {
    this.getBasketList();
  },
  methods: {
    //获取购物车列表
    async getBasketList() {
      let loadingInstance = Loading.service();
      try {
        let { data } = await this.$api.getBasketList();
        this.checkedAll = data.checked;
        this.basketList = data.takeInfoList;
        this.totalAmount = data.totalAmount;
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
      } catch (error) {
        console.log(error);
      }
    },
    //全部全选
    async handleSelectAll(val) {
      this.handleChecked(val, 0);
    },
    //提货方式全选
    async selectLogistic(val, takeType) {
      this.handleChecked(val, 1, takeType);
    },
    //店铺全选
    async changeShopSelectAll(val) {
      let { checked, checkedValue, takeType } = val;
      this.handleChecked(checked, 2, checkedValue, takeType);
    },
    //增加减少购买数量
    async changeCount(val) {
      await this.$api.incrOrDecrQty(val);
      this.getBasketList();
    },
    //商品选择
    chaneSelect(val) {
      let { checked, checkedValue, takeType } = val;
      this.handleChecked(checked, 3, checkedValue, takeType);
    },
    //删除商品
    async handleDelete(id) {
      try {
        await this.$api.removeBasket({ id });
        this.$message.success("删除成功");
        this.getBasketList();
      } catch (error) {
        console.log(error);
      }
    },
    //去结算
    toConfrimOrder() {
      let goodsData = {
        takeStoreInfoList: [],
        emsStoreInfoList: [],
      };
      this.basketList.map((take) => {
        let list = [];
        take.storeInfoList.map((shop) => {
          let itemList = shop.goodsInfoList
            .filter((fil) => fil.checked == 1)
            .map((good) => {
              return {
                qty: good.qty,
                skuId: good.skuId,
              };
            });
          list = itemList.concat(list);
        });
        if (take.takeType == 0) {
          goodsData.takeStoreInfoList = list;
        } else {
          goodsData.emsStoreInfoList = list;
        }
      });
      this.$router.push(
        `/e-shop/confirm-order?obj=${JSON.stringify({
          goodsData,
        })}&from=basket`
      );
    },
    async handleChecked(checked, checkedLevel, checkedValue = "", takeType = "") {
      const params = {
        checked: checked,
        checkedLevel,
        checkedValue,
        takeType,
      };
      try {
        await this.$api.setBasketChecked(params);
        this.getBasketList();
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.shop-cart {
  padding-bottom: 85px;
  .logistic-content {
    margin-top: 60px;
    .logistic-top {
      margin-bottom: 40px;
      .take-type-title {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
      }
    }
  }
  .footer {
    width: 100%;
    background: #e5e5e5;
    .footer-inner {
      height: 60px;
      margin-top: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .footer-right {
      .settle-btn {
        margin-left: 30px;
      }
    }
  }
}
</style>
